import React from 'react'
import { Link } from "react-router-dom";
import { Button, Text, useColorModeValue } from '@chakra-ui/react';
import { UserContext } from '../../Context/UserContext';

export function LinkButton({title, link, colorB}) {
    const { onClose } = React.useContext(UserContext);
    
    const hoverBg = useColorModeValue('brand.50', 'whiteAlpha.100');

    return (
        <Link to={link} onClick={onClose} style={{ textDecoration: 'none' }}>
            <Button 
                w={{ base: "full", md: "auto" }}
                variant='ghost' 
                justifyContent={{ base: "flex-start", md: "center" }}
                h="40px" // Altura fixa para alinhar com os Popovers
                px={4}
                borderRadius="full"
                _hover={{ bg: hoverBg }}
                _active={{ bg: 'transparent' }}
            >
                <Text 
                    color={colorB} 
                    fontSize="xs" 
                    fontWeight="800" 
                    letterSpacing="tighter"
                    textTransform="uppercase"
                >
                    {title}
                </Text>
            </Button >
        </Link>
    );
}

export default LinkButton;